var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H42C45.3137 0 48 2.68629 48 6V42C48 45.3137 45.3137 48 42 48H6C2.68629 48 0 45.3137 0 42V6Z",
    fill: "#FEF0C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9998 21.0002V25.0002M23.9998 29.0002H24.0098M22.6151 15.892L14.3902 30.0986C13.934 30.8866 13.7059 31.2806 13.7396 31.6039C13.769 31.886 13.9168 32.1423 14.1461 32.309C14.4091 32.5002 14.8643 32.5002 15.7749 32.5002H32.2246C33.1352 32.5002 33.5904 32.5002 33.8534 32.309C34.0827 32.1423 34.2305 31.886 34.2599 31.6039C34.2936 31.2806 34.0655 30.8866 33.6093 30.0986L25.3844 15.892C24.9299 15.1068 24.7026 14.7142 24.4061 14.5824C24.1474 14.4673 23.8521 14.4673 23.5935 14.5824C23.2969 14.7142 23.0696 15.1068 22.6151 15.892Z",
    stroke: "#DC6803",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/errorIcon.36f4d9dcdcfc1000e1e11f37fe554472.svg";
export { ForwardRef as ReactComponent };